import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FaEnvelope, FaPhone,FaUserTie } from 'react-icons/fa';
import api from '../../services/api';
import { getMediaUrl } from '../../services/api';
import './OfficerSection.css';

const OfficerSection = ({ section, layout = 'default' }) => {
  const [officers, setOfficers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadOfficers();
  }, []);

  const loadOfficers = async () => {
    try {
      const response = await api.get('/officers/', { params: { page_size: 12 } });
      const officersData = response.data.results || response.data;
      setOfficers(Array.isArray(officersData) ? officersData : []);
    } catch (error) {
      console.error('Error loading officers:', error);
      setOfficers([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <section className="officers-section homepage-section">
        <Container>
          <h2 className="section-title">{section.title}</h2>
          <div className="text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </Container>
      </section>
    );
  }

  if (officers.length === 0) return null;

  const renderGridLayout = () => (
    <Row className="justify-content-center g-4">
      {officers.map(officer => (
        <Col key={officer.id} lg={4} md={6} sm={12}>
          <Card className="officer-card h-100 shadow-sm">
            {officer.photo ? (
              <div className="officer-image-wrapper">
                <Card.Img 
                  variant="top" 
                  src={getMediaUrl(officer.photo)} 
                  alt={officer.name}
                  className="officer-image"
                />
              </div>
            ) : (
              <div className="officer-photo-placeholder">
                <FaUserTie size={80} />
              </div>
            )}
            {/* <Card.Body>
              <Card.Title className="officer-name">
                {officer.name}
              </Card.Title>
              <p className="officer-designation text-primary fw-bold mb-2">
                {officer.designation}
              </p>
              {officer.department && (
                <p className="text-muted small mb-2">
                  <i className="fas fa-building me-2"></i>
                  {officer.department.name || officer.department}
                </p>
              )}
              {officer.email && (
                <p className="contact-info mb-1">
                  <i className="fas fa-envelope me-2 text-info"></i>
                  <a href={`mailto:${officer.email}`}>{officer.email}</a>
                </p>
              )}
              {officer.phone && (
                <p className="contact-info mb-0">
                  <i className="fas fa-phone me-2 text-success"></i>
                  <a href={`tel:${officer.phone}`}>{officer.phone}</a>
                </p>
              )}
            </Card.Body> */}
            <Card.Body>
                <Card.Title className="officer-name">
                    {officer.name}
                </Card.Title>
                <p className="officer-designation">
                    {officer.designation}
                </p>
                <p className="officer-department">
                    {officer.department_name || '-'}
                </p>
                
                {officer.email && (
                    <div className="contact-info">
                    <i className="fas fa-envelope text-info"></i>
                    <a href={`mailto:${officer.email}`}>{officer.email}</a>
                    </div>
                )}
                {officer.phone && (
                    <div className="contact-info">
                    <i className="fas fa-phone text-success"></i>
                    <a href={`tel:${officer.phone}`}>{officer.phone}</a>
                    </div>
                )}
            </Card.Body>

          </Card>
        </Col>
      ))}
    </Row>
  );

  const renderCompactLayout = () => (
    <Row className="justify-content-center g-3">
      {officers.map(officer => (
        <Col key={officer.id} lg={3} md={4} sm={6} xs={12}>
          <div className="officer-compact-card text-center p-3 rounded border">
            {officer.photo && (
              <div className="officer-avatar mb-3">
                <img 
                  src={getMediaUrl(officer.photo)} 
                  alt={officer.name}
                  className="rounded-circle"
                
                />
              </div>
            )}
            <h5 className="officer-name-compact mb-1">{officer.name}</h5>
            <p className="text-primary small fw-bold mb-2">{officer.designation}</p>
            {officer.phone && (
              <p className="text-muted small">
                <i className="fas fa-phone me-1"></i>{officer.phone}
              </p>
            )}
            {officer.email && (
              <p className="text-muted small">
                <a href={`mailto:${officer.email}`} className="text-decoration-none">
                  <i className="fas fa-envelope me-1"></i>Email
                </a>
              </p>
            )}
          </div>
        </Col>
      ))}
    </Row>
  );

  const renderListLayout = () => (
    <div className="officer-list">
      {officers.map(officer => (
        <div key={officer.id} className="officer-list-item py-4 border-bottom">
          <Row>
            {officer.photo && (
              <Col md={2} sm={3} xs={4} className="mb-2 mb-md-0">
                <img 
                  src={getMediaUrl(officer.photo)} 
                  alt={officer.name}
                  className="img-fluid rounded"
                />
              </Col>
            )}
            <Col md={officer.photo ? 10 : 12} sm={9} xs={8}>
              <h5 className="officer-name">{officer.name}</h5>
              <p className="text-primary fw-bold mb-2">{officer.designation}</p>
              {/* {officer.department && (
                <p className="text-muted small mb-2">
                  <strong>Department:</strong> {officer.department.name || officer.department}
                </p>
              )} */}
              <div className="contact-links">
                {officer.phone && (
                  <a href={`tel:${officer.phone}`} className="btn btn-sm btn-outline-success me-2">
                    <i className="fas fa-phone me-1"></i>Call
                  </a>
                )}
                {officer.email && (
                  <a href={`mailto:${officer.email}`} className="btn btn-sm btn-outline-info">
                    <i className="fas fa-envelope me-1"></i>Email
                  </a>
                )}
              </div>
            </Col>
          </Row>
        </div>
      ))}
    </div>
  );

  return (
    <section className="officers-section homepage-section">
      <Container>
        <h2 className="section-title">{section.title}</h2>
        {layout === 'compact' && renderCompactLayout()}
        {layout === 'list' && renderListLayout()}
        {layout === 'default' && renderGridLayout()}
      </Container>
    </section>
  );
};

export default OfficerSection;
